import React from 'react';
import { ReactComponent as Svg } from './images/downloadAppStore.svg';

/**
 * Apple's black "Download on the App Store" badge, inlined into the bundle.
 *
 * As an <img> (local or from toolbox.marketingtools.apple.com) the badge was
 * only requested after the script had rendered, so it popped in a beat after
 * the page. Inline SVG paints with the page and needs no request at all.
 * Default size matches the 162x54 the pages used for the <img>.
 */
export default function AppStoreBadgeSvg({ width = 162, height = 54, className, style }) {
  return (
    <Svg
      title="Download on the App Store"
      role="img"
      width={width}
      height={height}
      className={className}
      style={style}
      focusable="false"
    />
  );
}
